import React, { useEffect } from 'react';
import { sendTrackingInfo, ModalCreditsOptions } from '@panel/commons';
import { useTranslation } from 'react-i18next';

function FreemiumFlowOffToOnCreditsNoFreeYes(props) {
  const { onClickAction, onClickFreemium, postingId, plans, isInmobiliaria } = props;
  const { t } = useTranslation();

  useEffect(() => {
    sendTrackingInfo('Mis avisos', `Republicar Aviso_${isInmobiliaria ? 'Inmobiliaria' : 'Particular'}-Intencion`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleBuyCredits = e => {
    sendTrackingInfo(
      'Mis avisos',
      `Republicar Aviso Sin credito_Adquirir Credito_${isInmobiliaria ? 'Inmobiliaria' : 'Particular'}`
    );
    onClickAction(e);
  };

  const handleCancel = e => {
    sendTrackingInfo(
      'Mis avisos',
      `Republicar Aviso Sin credito_Cancelar_${isInmobiliaria ? 'Inmobiliaria' : 'Particular'}`
    );
    onClickAction(e);
  };

  const handleClickFreemium = e => {
    sendTrackingInfo(
      'Mis avisos',
      `Republicar Aviso Sin credito_Activar Gratis_${isInmobiliaria ? 'Inmobiliaria' : 'Particular'}`
    );
    onClickFreemium(e);
  };

  const siteId = process.env.REACT_APP_BUILD_SITE;
  const newLocation = ['UBPE', 'DVPE', 'ZPAR', '24MX', 'IWBR', 'WIBR', 'PLEC', 'CAPA'].includes(siteId)
    ? `/panel/publicador/principales/operacionypropiedad?postingId=${postingId}`
    : `..${t('panel.url.ecommerce.particular')}?idPosting=${postingId}`;

  return (
    <ModalCreditsOptions
      onClickAction={e => handleBuyCredits(e)}
      onClickFreemium={e => handleClickFreemium(e)}
      onClickOutside={handleCancel}
      plans={plans}
      title={t('panel.modal.FreemiumFlowOffToOnCreditsNoFreeYes.title')}
      subTitle={t('panel.modal.FreemiumFlowOffToOnCreditsNoFreeYes.subtitle')}
      ctaFreemium={t('panel.modal.cta.freeActivation')}
      urlLink={newLocation}
      ctaAnchor={t('panel.modal.cta.buyCredits')}
    />
  );
}

export { FreemiumFlowOffToOnCreditsNoFreeYes };
